import { BrowserRouter, Routes, Route } from 'react-router-dom';
import '@/App.css';
import { Toaster } from 'sonner';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import LiveChat from '@/components/LiveChat';
import Home from '@/pages/Home';
import About from '@/pages/About';
import Services from '@/pages/Services';
import Team from '@/pages/Team';
import WhyChooseUs from '@/pages/WhyChooseUs';
import Contact from '@/pages/Contact';
import QuickStart from '@/pages/QuickStart';
import SAMIncubator from '@/pages/SAMIncubator';
import SAMTalents from '@/pages/SAMTalents';
import SAMSolutions from '@/pages/SAMSolutions';

function App() {
  return (
    <BrowserRouter>
      <div className="App smooth-scroll">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/team" element={<Team />} />
          <Route path="/why-choose-us" element={<WhyChooseUs />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/quick-start" element={<QuickStart />} />
          <Route path="/sam-incubator" element={<SAMIncubator />} />
          <Route path="/sam-talents" element={<SAMTalents />} />
          <Route path="/sam-solutions" element={<SAMSolutions />} />
        </Routes>
        <Footer />
        <LiveChat />
        <Toaster position="top-right" richColors />
      </div>
    </BrowserRouter>
  );
}

export default App;